import { Controller, useForm } from 'react-hook-form'
import { QuestCategoryEditFormProps } from './types'
import { CateroryCreateModel, CategoryModel } from 'shared/models'
import { Box, Button, Card, Tab, TextField } from '@mui/material'
import { yupResolver } from '@hookform/resolvers/yup'
import { getValidations } from './validation'
import { TabContext, TabList, TabPanel } from '@mui/lab'
import { useState } from 'react'

function QuestCategoryEditForm({ defaultData, onSubmit, isProcess, onDelete, isEdit }: QuestCategoryEditFormProps) {
  const [isDeleting, setIsDeleting] = useState(false)

  const { control, handleSubmit } = useForm<CategoryModel | CateroryCreateModel>({
    defaultValues: defaultData,
    disabled: isProcess,
    resolver: yupResolver<CategoryModel | CateroryCreateModel>(getValidations())
  })

  function handleDelete() {
    setIsDeleting(true)
  }

  function cancelDelete() {
    setIsDeleting(false)
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Card elevation={1}>
        <TabContext value="main">
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList>
              <Tab label="Основная информация" value="main" />
            </TabList>
          </Box>
          <TabPanel value="main">
            <Controller
              control={control}
              name="name"
              defaultValue=""
              render={({ field, fieldState }) => (
                <TextField
                  label="Название"
                  fullWidth
                  autoComplete="off"
                  placeholder="Название"
                  variant="standard"
                  InputLabelProps={{ shrink: true }}
                  value={field.value}
                  onChange={field.onChange}
                  onBlur={field.onBlur}
                  disabled={isProcess}
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                  ref={field.ref}
                  margin="none"
                />
              )}
            />
          </TabPanel>
        </TabContext>
      </Card>
      {!isDeleting && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3, gap: '1rem' }}>
          {isEdit && (
            <Button onClick={handleDelete} disabled={isProcess}>
              Удалить
            </Button>
          )}
          <Button type="submit" variant="outlined" disabled={isProcess}>
            Сохранить
          </Button>
        </Box>
      )}
      {isDeleting && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', mt: 3, gap: '1rem' }}>
          Вы действительно хотите удалить категорию?
          <Button onClick={cancelDelete} disabled={isProcess}>
            Отмена
          </Button>
          <Button variant="outlined" color="error" disabled={isProcess} onClick={onDelete}>
            Удалить
          </Button>
        </Box>
      )}
    </form>
  )
}

export { QuestCategoryEditForm }
